var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Footer',[_c('div',[_c('img',{attrs:{"src":require("../assets/code.jpg"),"alt":""}}),_vm._v(" "),_c('div',[_c('h2',[_vm._v("娃娃鱼动画")]),_vm._v(" "),_c('p',[_vm._v("拱墅区祥园路88号中国智慧信息产业园H楼7楼  0571-88077081")]),_vm._v(" "),_c('p',[_vm._v("Copyright © 2015-2020    浙ICP备15008765号-1")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ccc1355","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--0-1!./src/components/footerItem.vue
// module id = null
// module chunks = 